import {
  getDescriptionMaxHeight,
  getPinMeasurements,
} from 'app/common/react/components/growth/unauth/pin/pinUtils';

export default function cssStyles(seoUnauthExperiments, pageType) {
  let styles = '';
  const lineHeight = getPinMeasurements(seoUnauthExperiments).descriptionLineHeight;
  const lineMaxHeight = getDescriptionMaxHeight(seoUnauthExperiments);
  const maxLines = getPinMeasurements(seoUnauthExperiments).maxNumDescriptionLines;
  let groupName = '';
  if (seoUnauthExperiments) {
    if (pageType === 'board') {
      groupName =
        seoUnauthExperiments.v2GetGroup('pin_grid_style_format_optimization_board_v3') || '';
    } else if (pageType === 'pin') {
      groupName =
        seoUnauthExperiments.v2GetGroup('pin_grid_style_format_optimization_pin_v3') || '';
    }
  }

  const inPinGridOptGroup = groupName.startsWith('enabled');

  const inCleanupPinGridGroup = groupName.startsWith('enabled_clean');

  styles += `
  .pinDescription_attribute_container {
      display: flex;
      flex-direction: column;
  }

  summary::-webkit-details-marker {
    display: none
  }

  .PinDescriptionSeeMore_details {
    margin-top: -15px;
  }
  `;

  if (inPinGridOptGroup || pageType === 'topic') {
    styles += `
      .PinDescription__desc {
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: ${lineMaxHeight}px;
        display: -webkit-box;
        -webkit-box-orient: vertical;

        color: #333;
        font-size: 13px;
        line-height: 17px;
        margin: 5px 0;
        -moz-osx-font-smoothing: grayscale;
        padding: 0;
        text-align: left;
        -webkit-font-smoothing: antialiased;
        word-wrap: break-word;
      }

      .pinDescriptionPinner__image {
        border-radius: 50%;
        -webkit-box-shadow: 0 0 2px rgba(0,0,0,0.33) inset;
        box-shadow: 0 0 2px rgba(0,0,0,0.33) inset;
        content: ' ';
        height: 24px;
        left: 0;
        position: absolute;
        top: 0;
        width: 24px;
        margin-left: 4px;
        margin-right: 4px;
      }

      .pinDescription_text {
        color: #333;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: -.4px;
        margin: 0;
        overflow: hidden;
        padding: 0 4px;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 180px;
        color: #333;
        letter-spacing: -.4px;
      }

      .pinDescription_pinnerBoardAttribution {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
      }

      .pinDescription_pinnerProfileImage {
        border-radius: 50%;
        position: relative;
        float: left;
        height: 24px;
        width: 24px;
        display: block;
        margin-right: 4px;
      }

      .vaseCarousel_vasetags_container {
        overflow: hidden;
        position: relative;
      }

      .vaseCarousel_vasetags_wrapper {
        overflow: scroll;
        white-space: nowrap;
        padding: 3px 0 22px 0;
      }

      .vaseCarousel_vaseTagLink {
        background-color: #ebebe8;
        border-radius: 5px;
        color: #333;
        display: inline-block;
        font-size: 9px;
        font-weight: bold;
        margin: 0 5px 0 0;
        padding: 7px 7px;
        white-space: nowrap;
        word-wrap: break-word;
      }

      .VaseCarousel__button {
        display: block;
        height: 30px;
        top: 0px;
        position: absolute;
        width: 45px;
        line-height: 25px;
        padding-left: 4px;
        padding-top: 2px;
      }

      .VaseCarousel__buttonLeft {
        left: 0px;
        background: -webkit-linear-gradient(left, rgba(255,255,255,1) 25%,rgba(255,255,255,0) 100%);
      }

      .VaseCarousel__buttonRight {
        right: 0px;
        text-align: right;
        background: -webkit-linear-gradient(right, rgba(255,255,255,1) 25%,rgba(255,255,255,0) 100%);
      }

      .HiddenDescriptions_vasetags_title {
        font-size: 14px;
        margin-top: 20px;
        font-weight: bold;
      }

      .HiddenDescriptions_vasetags {
        font-family: HelveticaNeue;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.17;
        letter-spacing: -0.1px;
        color: #333333;
        margin: 8px 0;
        display: flex;
      }

      .pinDescription_text_board {
        font-weight: 400;
      }

      `;

    for (let i = 0; i <= maxLines; i += 1) {
      styles += `
          .PinDescription__${i}LineDesc {
            height: ${i * lineHeight}px;
            -webkit-line-clamp: ${i};
          }
        `;
    }
  } else {
    styles += `
    .PinDescription__desc {
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: ${lineMaxHeight}px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }

    .underlineLink:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    `;

    for (let i = 0; i <= maxLines; i += 1) {
      styles += `
        .PinDescription__${i}LineDesc {
          height: ${i * lineHeight}px;
          -webkit-line-clamp: ${i};
        }
      `;
    }
  }

  if (inCleanupPinGridGroup) {
    styles += `
    .pinDescription_text {
      width: 160px;
    }

    .PinDescriptionSeeMore_summary {
      background-color: transparent;
      color: #333;
      font-size: 12px;
      font-weight: bold;
      -moz-osx-font-smoothing: grayscale;
      outline: none;
      -webkit-font-smoothing: antialiased;
      display: flex;
      justify-content: flex-end;
    }
    `;
  }

  return styles;
}
